import lj from './lumberjack';

const interestForm = document.querySelector('form.interest-form');

// TODO: Need to find the actual reason for analytics not working
// This is workaround
let utm = null,
  gclid = null,
  midExists = false,
  browser_details = {};

if (typeof window.razorpayAnalytics !== 'undefined') {
  utm = razorpayAnalytics.utils.getLandingParams();
  gclid = razorpayAnalytics.utils.getCookie('gclid');
  browser_details = razorpayAnalytics.utils.getBrowserDetails();
  midExists = razorpayAnalytics.utils.getCookie('midExists') || false;
}

lj.commonProperties = {
  utm_params: utm,
  gclid: gclid,
  mode: 'live',
  reffering_url: document.referrer,
  url: document.location.href
};

// First fold Get Started
document
  .querySelector('button#get-started-first-fold')
  .addEventListener('click', e => {
    lj.pushEvents({
      event_name: 'partnerships.appstore.developer.getstarted',
      event_type: 'success',
      properties: {
        location: 'first-fold'
      }
    });
  });

// Second fold get started
document
  .querySelector('button#get-started-second-fold')
  .addEventListener('click', e => {
    lj.pushEvents({
      event_name: 'partnerships.appstore.developer.getstarted',
      event_type: 'success',
      properties: {
        location: 'second-fold'
      }
    });
  });

// When user closes the interest form
document.querySelector('#interest-form-close').addEventListener('click', e => {
  lj.pushEvents({
    event_name: 'partnerships.appstore.developer.formclose',
    event_type: 'success'
  });
});

// Know more button on last fold
document.querySelector('a#know-more-button').addEventListener('click', e => {
  lj.pushEvents({
    event_name: 'partnerships.appstore.developer.knowmore',
    event_type: 'success'
  });
});

// API Link tracking
document
  .querySelectorAll('.apis-image-container a.api-card')
  .forEach(anchorEl => {
    anchorEl.addEventListener('click', e => {
      lj.pushEvents({
        event_name: 'partnerships.appstore.developer.apiclicked',
        event_type: 'success',
        properties: {
          apiLink: anchorEl.href
        }
      });
    });
  });

// Form Submit Event

document
  .querySelector('#interest-form-submit-button')
  .addEventListener('click', e => {
    e.preventDefault();

    const properties = {
      name: interestForm.querySelector('#name').value,
      email: interestForm.querySelector('#email').value,
      phone: interestForm.querySelector('#phone').value,
      productIdea: interestForm.querySelector('#product-idea').value
    };

    // https://stackoverflow.com/questions/7635533/validate-email-address-textbox-using-javascript/7635734
    if (
      !/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(
        properties.email
      )
    ) {
      // email is wrong
      alert('Email id is invalid');
      return;
    }

    if (properties.phone.length !== 10) {
      alert('Phone number should be 10 digits');
      return;
    }

    if (!properties.name) {
      alert('Name cannot be empty');
      return;
    }

    if (!properties.productIdea) {
      alert('Product description cannot be empty');
      return;
    }

    lj.pushEvents({
      event_name: 'partnerships.appstore.developer.formsubmit',
      event_type: 'success',
      properties: properties
    });

    document.querySelector(
      '.interest-form-container .after-success'
    ).style.display = 'block';

    // Close modal in 3 seconds
    setTimeout(() => {
      document
        .querySelector('#appstore-interest-form')
        .classList.remove('show');
      document.querySelector('#appstore-interest-form').style.display = 'none';
      document.querySelector('#modal-overlay').outerHTML = '';
      document.querySelector(
        '.interest-form-container .after-success'
      ).style.display = 'none';
    }, 3000);

    return false;
  });
